module.exports = __webpack_public_path__ + "img/share_qrcode.fff5ed27.svg";